(function () {

    'use strict';

    angular.module('asys')
        .controller('ModalKundenportalLoginController', ModalKundenportalLoginController);

    ModalKundenportalLoginController.$inject = [
        '$modalInstance',
        '$log'
    ];

    function ModalKundenportalLoginController($modalInstance, $log) {
        var vm = this;

        $log.debug('ModalKundenportalLoginController', vm);

        vm.onLogin = onLogin;
        vm.onClose = onClose;

        activate();

        function activate() {}
        function onLogin() {
            $modalInstance.close();
        }
        function onClose() {
            $modalInstance.dismiss();
        }
    }

})();
